var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStartupScoringVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 160,
    viewBox: "0 0 161 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_209_417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.307 99.7202C150.3 86.3964 146.439 73.3592 139.189 62.1806L131.989 69.3854C137.45 78.5617 140.334 89.0418 140.335 99.7202H150.307ZM140.335 46.9384L133.285 39.8882L90.57 82.6033C87.5305 80.7711 84.0523 79.7943 80.5033 79.7762C76.5588 79.7762 72.7028 80.9459 69.423 83.1374C66.1432 85.3289 63.587 88.4437 62.0775 92.088C60.5679 95.7323 60.173 99.7423 60.9425 103.611C61.7121 107.48 63.6116 111.034 66.4008 113.823C69.19 116.612 72.7437 118.511 76.6124 119.281C80.4812 120.051 84.4913 119.656 88.1355 118.146C91.7798 116.637 94.8947 114.08 97.0861 110.801C99.2776 107.521 100.447 103.665 100.447 99.7202C100.43 96.1695 99.4533 92.6895 97.6202 89.6485L140.335 46.9384ZM80.5033 109.692C78.531 109.692 76.6031 109.107 74.9632 108.012C73.3233 106.916 72.0451 105.358 71.2904 103.536C70.5356 101.714 70.3381 99.7092 70.7229 97.7748C71.1077 95.8404 72.0574 94.0636 73.452 92.669C74.8466 91.2743 76.6235 90.3246 78.5579 89.9398C80.4922 89.5551 82.4973 89.7525 84.3194 90.5073C86.1416 91.2621 87.699 92.5402 88.7947 94.1801C89.8905 95.82 90.4753 97.7479 90.4753 99.7202C90.4753 102.365 89.4247 104.901 87.5546 106.771C85.6845 108.642 83.148 109.692 80.5033 109.692ZM80.5033 39.8882C91.1801 39.8909 101.658 42.7744 110.833 48.2348L118.083 40.9901C107.547 34.215 95.3806 30.4047 82.8627 29.96C70.3447 29.5153 57.9383 32.4526 46.9487 38.4631C35.959 44.4735 26.7925 53.3348 20.4134 64.1147C14.0344 74.8945 10.6787 87.1944 10.6993 99.7202H20.6713C20.6898 83.8575 26.9994 68.6497 38.2161 57.433C49.4328 46.2163 64.6405 39.9067 80.5033 39.8882Z",
    fill: "url(#paint0_linear_209_417)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_209_417",
    x: -214.589,
    y: -195.372,
    width: 590.184,
    height: 540.325,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 112.644
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.328677 0 0 0 0 0.122116 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_209_417"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_209_417",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_209_417",
    x1: 86.8411,
    y1: 61.0384,
    x2: -4.10609,
    y2: 64.6452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF541F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAD1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartupScoringVector);
export default __webpack_public_path__ + "static/media/StartupScoringVector.f84ce48c5a6b3b84963bee40c8e82ae1.svg";
export { ForwardRef as ReactComponent };